export default __webpack_public_path__ + "media/images/field-1-0c2e498e1333b69e208e8c77ef12b8f7.png";